/* eslint-disable react/prop-types */
import React, { useState } from "react";
//Elements
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import { logOut } from "../services/auth";
//Static Images and Icons
import SignaclassLogo from "../../images/square-roundel-smaller.png";
//Icon Library
import {
  MdMenu,
  MdMenuOpen,
  MdOutlineHome,
  MdClass,
  MdCalendarViewMonth,
  MdPeopleAlt,
  MdOutlineEmojiPeople,
  MdSettings,
  MdStars,
  MdOutlineLogout,
  MdCopyright,
} from "react-icons/md";
import NavbarBrand from "../../common/NavbarBrand";

const AdminNavigation = (props) => {
  return (
    <Navbar
      variant={props.generalTheme}
      bg='custom'
      expand='lg'
      className='pt-2'
      style={{ backgroundColor: props.brandColour }}
    >
      <Container>
        <NavbarBrand direction='/admin/overview/' />
        <SlideNav />
      </Container>
    </Navbar>
  );
};

const SlideNav = () => {
  const [adminMenuShow, setAdminMenuShow] = useState(false);
  const handleAdminMenuClose = () => setAdminMenuShow(false);
  const handleAdminMenuShow = () => setAdminMenuShow(true);
  const getYear = () => {
    return new Date().getFullYear();
  };
  return (
    <div>
      <Nav className='ml-auto mr-2'>
        <Nav.Link onClick={handleAdminMenuShow}>
          {!adminMenuShow && <MdMenu size='3em' />}
          {adminMenuShow && <MdMenuOpen size='3em' />}
        </Nav.Link>
      </Nav>
      <Offcanvas
        show={adminMenuShow}
        onHide={handleAdminMenuClose}
        className='d-flex flex-column flex-shrink-0 p-3 sidebar'
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={SignaclassLogo} className='signaclass-logo' alt='logo' />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className='nav nav-pills flex-column'>
            <li className='nav-item offcanvas-nav-item'>
              <Link to='/admin/overview/' onClick={handleAdminMenuClose}>
                <MdCalendarViewMonth size='1.3em' className='me-2' />
                Overview
              </Link>
            </li>
            <li className='nav-item offcanvas-nav-item'>
              <Link to='/admin/venue-list/' onClick={handleAdminMenuClose}>
                <MdOutlineHome size='1.3em' className='me-2' />
                Venues
              </Link>
            </li>
            <li className='nav-item offcanvas-nav-item'>
              <Link to='/admin/class-types/' onClick={handleAdminMenuClose}>
                <MdClass size='1.3em' className='me-2' />
                Class Types
              </Link>
            </li>
            <li className='nav-item offcanvas-nav-item'>
              <Link to='/admin/customer-list/' onClick={handleAdminMenuClose}>
                <MdPeopleAlt size='1.3em' className='me-2' />
                Customers
              </Link>
            </li>
            <li className='nav-item offcanvas-nav-item'>
              <Link to='/admin/tutor-list/' onClick={handleAdminMenuClose}>
                <MdOutlineEmojiPeople size='1.3em' className='me-2' />
                Tutors
              </Link>
            </li>
            <li className='nav-item offcanvas-nav-item'>
              <Link to='/admin/awards/' onClick={handleAdminMenuClose}>
                <MdStars size='1.3em' className='me-2' />
                Awards
              </Link>
            </li>
            <li className='nav-item offcanvas-nav-item'>
              <Link to='/admin/configure/' onClick={handleAdminMenuClose}>
                <MdSettings size='1.3em' className='me-2' />
                Configure
              </Link>
            </li>
          </ul>
          <div className='mt-auto'>
            <hr />
            <Button variant='primary' size='lg' onClick={logOut}>
              <MdOutlineLogout /> LOGOUT
            </Button>
            <div className='mt-2'>
              <small>
                <span className='copyright-bar'>
                  Software <MdCopyright /> {getYear()}{" "}
                  <a href='https://signaclass.com'>Signaclass</a>. All Rights Reserved.
                </span>
              </small>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default AdminNavigation;
